{
  "unauthorizedRoute": {
    "subtitle": "Sie haben keine Berechtigung, auf diese Seite zuzugreifen",
    "title": "Nicht autorisiert"
  },
  "pageNotFound": "Seite nicht gefunden",
  "httpStatusCodes": {
    "400": {
      "title": "Fehlerhafte Anfrage",
      "subtitle": "Ein Fehler aufgrund einer fehlerhaften Anfrage ist aufgetreten. Bitte überprüfen Sie Ihre Daten und versuchen Sie es erneut.",
      "codes": {
        "INVALID_VALUE_NOT_NULL": "Das Feld „{field}“ ist erforderlich.",
        "JSON_NOT_VALID": "Der Inhalt ist nicht in einem gültigen JSON-Format.",
        "SCHEMA_NOT_MATCH": "Der Inhalt entspricht nicht dem erwarteten Muster.",
        "SCHEMA_NOT_MATCH_FIELD": "Der Inhalt stimmt nicht mit dem erwarteten Schema überein, Fehler bei der Eigenschaft „{field}“.",
        "CERTIFICATE_RENEWAL_FAILED_NO_DNS_MATCH": "DNS und CN stimmen nicht mit der Zertifikatsparametrierung überein."
      }
    },
    "409": {
      "title": "Konfliktfehler",
      "subtitle": "Ein Konfliktfehler ist aufgetreten. Bitte überprüfen Sie Ihre Daten und versuchen Sie es erneut.",
      "codes": {
        "UNICITY_CONSTRAINT": "Der Wert des Feldes „{field}“ wird bereits verwendet.",
        "UNICITY_CONSTRAINT_FIELD_LOGIN": "Der Benutzername wird bereits verwendet.",
        "UNICITY_CONSTRAINT_FIELD_EMAIL": "Die E-Mail-Adresse wird bereits verwendet.",
        "UNICITY_CONSTRAINT_FIELD_NAME_ORGANIZATION": "Der Organisationsname wird bereits verwendet.",
        "UNICITY_CONSTRAINT_FIELD_USER_GROUP": "Eine Benutzergruppe mit diesem Namen ist bereits vorhanden.",
        "UNICITY_CONSTRAINT_FIELD_USER_PROFILE": "Ein Profil mit diesem Namen ist bereits vorhanden."
      }
    },
    "404": {
      "title": "Nicht gefunden",
      "subtitle": "Die Ressource wurde nicht gefunden."
    },
    "401": {
      "title": "Nicht autorisiert",
      "subtitle": "Sie sind nicht angemeldet."
    },
    "403": {
      "title": "Verboten",
      "subtitle": "Sie sind nicht berechtigt, diese Aktion auszuführen.",
      "codes": {
        "SECTOR_DEPTH_EXCEEDED": "Die maximale Sektortiefe darf {maximum_allowed_depth} nicht überschreiten.",
        "SECTOR_DELETE_FORBIDDEN": "Der Sektor kann nicht gelöscht werden, da einige Geräte daran angeschlossen sind."
      }
    },
    "500": {
      "title": "Es ist ein Fehler aufgetreten",
      "subtitle": "Bitte versuchen Sie es zu einem anderen Zeitpunkt erneut."
    },
    "405": {
      "title": "Nicht erlaubt",
      "subtitle": "Sie sind nicht berechtigt, diese Aktion auszuführen."
    },
    "408": {
      "title": "Wir konnten die Seite nicht laden",
      "subtitle": "Die Anfrage hat zu viel Zeit in Anspruch genommen."
    }
  },
  "download": {
    "noData": "Keine Daten zum Herunterladen"
  }
}
